<template>
  <div class="page template-documentos-page">
    <div v-if="carregandoInicial" class="template-documentos-loading">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <template v-else>
      <TemplateDocumentosToolbar
        :alias-selecionado="aliasSelecionado"
        :opcoes-documento="opcoesDocumento"
        :personalizado="personalizadoAtual"
        :onde-usado="ondeUsadoTexto"
        :disabled="carregandoDetalhe"
        @update:aliasSelecionado="onTrocarDocumento"
      />

      <v-row class="template-documentos-corpo" align="stretch">
        <v-col cols="12" md="8" class="template-documentos-col-editor">
          <TemplateDocumentosEditor
            ref="editor"
            v-model="htmlDraft"
            :disabled="carregandoDetalhe"
          />
        </v-col>
        <v-col cols="12" md="4" class="template-documentos-col-variaveis">
          <TemplateDocumentosVariaveisPanel
            :variaveis="detalhe.variaveis"
            @inserir="onInserirVariavel"
          />
        </v-col>
      </v-row>

      <TemplateDocumentosActionBar
        :dirty="dirty"
        :carregando="carregandoDetalhe"
        :desabilitado="!aliasSelecionado"
        :salvar-loading="salvando"
        :preview-loading="previewLoading"
        :restaurar-loading="restaurando"
        @copiar="onCopiar"
        @preview="onPreview"
        @restaurar="onRestaurar"
        @salvar="onSalvar"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import confirmAlert from "@/mixins/confirmAlert.vue";
import TemplateDocumentosToolbar from "./components/TemplateDocumentosToolbar";
import TemplateDocumentosEditor from "./components/TemplateDocumentosEditor";
import TemplateDocumentosVariaveisPanel from "./components/TemplateDocumentosVariaveisPanel";
import TemplateDocumentosActionBar from "./components/TemplateDocumentosActionBar";
import {
  ALIASES_DOCUMENTO_ORDEM,
  WHERE_USED_BY_ALIAS,
  montarOpcoesDocumento
} from "./template-documentos.constants";
import {
  TEMPLATE_DOCUMENTOS_LISTAR,
  TEMPLATE_DOCUMENTOS_OBTER,
  TEMPLATE_DOCUMENTOS_SALVAR,
  TEMPLATE_DOCUMENTOS_RESTAURAR,
  TEMPLATE_DOCUMENTOS_PREVIEW_PDF
} from "@/store/actions/templateDocumentos";
import * as _ from "lodash";

export default {
  name: "TemplateDocumentos",
  components: {
    TemplateDocumentosToolbar,
    TemplateDocumentosEditor,
    TemplateDocumentosVariaveisPanel,
    TemplateDocumentosActionBar
  },
  mixins: [confirmAlert],
  data: () => ({
    carregandoInicial: true,
    carregandoDetalhe: false,
    listagem: [],
    aliasSelecionado: ALIASES_DOCUMENTO_ORDEM[0],
    detalhe: {},
    htmlDraft: "",
    htmlSalvo: "",
    salvando: false,
    previewLoading: false,
    restaurando: false,
    previewUrl: "",
    previewBlob: null
  }),
  computed: {
    ...mapGetters(["getFornecedorId"]),
    opcoesDocumento() {
      return montarOpcoesDocumento(this.listagem);
    },
    personalizadoAtual() {
      if (this.detalhe && typeof this.detalhe.personalizado === "boolean") {
        return this.detalhe.personalizado;
      }
      const item = (this.listagem || []).find(
        i => i.alias_documento === this.aliasSelecionado
      );
      return item ? !!item.personalizado : false;
    },
    ondeUsadoTexto() {
      const desc = _.get(this.detalhe, "descricao", "");
      if (desc) return desc;
      return (
        WHERE_USED_BY_ALIAS[this.aliasSelecionado] ||
        "Documento comercial exportado pela plataforma."
      );
    },
    dirty() {
      return (this.htmlDraft || "") !== (this.htmlSalvo || "");
    }
  },
  watch: {
    getFornecedorId: {
      handler(novo, antigo) {
        if (novo && novo !== antigo) {
          this.inicializar();
        }
      }
    }
  },
  created() {
    this.inicializar();
  },
  beforeDestroy() {
    this.limparPreviewUrl();
  },
  methods: {
    async inicializar() {
      if (!this.getFornecedorId) return;
      this.carregandoInicial = true;
      try {
        this.listagem = await this.$store.dispatch(TEMPLATE_DOCUMENTOS_LISTAR);
        if (!this.aliasSelecionado && this.opcoesDocumento.length) {
          this.aliasSelecionado = this.opcoesDocumento[0].value;
        }
        await this.carregarDetalhe(this.aliasSelecionado);
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarDetalhe(alias) {
      if (!alias || !this.getFornecedorId) return;
      this.carregandoDetalhe = true;
      try {
        const detalhe = await this.$store.dispatch(
          TEMPLATE_DOCUMENTOS_OBTER,
          alias
        );
        this.detalhe = detalhe || {};
        const html = _.get(detalhe, "html_efetivo", "") || "";
        this.htmlDraft = html;
        this.htmlSalvo = html;
        this.atualizarPersonalizadoNaListagem(alias, !!detalhe.personalizado);
      } finally {
        this.carregandoDetalhe = false;
      }
    },
    atualizarPersonalizadoNaListagem(alias, personalizado) {
      this.listagem = (this.listagem || []).map(item =>
        item.alias_documento === alias ? { ...item, personalizado } : item
      );
    },
    onTrocarDocumento(novoAlias) {
      if (novoAlias === this.aliasSelecionado) return;
      const aplicar = () => {
        this.aliasSelecionado = novoAlias;
        this.carregarDetalhe(novoAlias);
      };
      if (!this.dirty) {
        aplicar();
        return;
      }
      this.confirmSwal(
        {
          title: "Descartar alterações?",
          text: "Há HTML não salvo. Trocar de documento descarta o rascunho."
        },
        aplicar
      );
    },
    onInserirVariavel(chave) {
      if (this.$refs.editor) {
        this.$refs.editor.inserirVariavel(chave);
      }
    },
    async onSalvar() {
      if (!this.aliasSelecionado || !this.htmlDraft.trim()) {
        this.$vueOnToast.pop(
          "warning",
          "Informe o HTML do layout antes de salvar."
        );
        return;
      }
      this.salvando = true;
      try {
        const salvo = await this.$store.dispatch(TEMPLATE_DOCUMENTOS_SALVAR, {
          aliasDocumento: this.aliasSelecionado,
          html: this.htmlDraft
        });
        const html = _.get(salvo, "html_efetivo", this.htmlDraft);
        this.htmlDraft = html;
        this.htmlSalvo = html;
        this.detalhe = salvo || this.detalhe;
        this.atualizarPersonalizadoNaListagem(this.aliasSelecionado, true);
        this.$vueOnToast.pop("success", "Layout salvo com sucesso.");
      } finally {
        this.salvando = false;
      }
    },
    onRestaurar() {
      this.confirmSwal(
        {
          title: "Restaurar padrão LifeApps",
          text:
            "A customização deste documento será removida. O HTML voltará ao modelo padrão da plataforma. Deseja continuar?"
        },
        () => this.executarRestaurar()
      );
    },
    async executarRestaurar() {
      this.restaurando = true;
      try {
        const restaurado = await this.$store.dispatch(
          TEMPLATE_DOCUMENTOS_RESTAURAR,
          this.aliasSelecionado
        );
        this.detalhe = restaurado || {};
        const html = _.get(restaurado, "html_efetivo", "") || "";
        this.htmlDraft = html;
        this.htmlSalvo = html;
        this.atualizarPersonalizadoNaListagem(this.aliasSelecionado, false);
        this.$vueOnToast.pop("success", "Layout padrão restaurado.");
      } finally {
        this.restaurando = false;
      }
    },
    async onPreview() {
      this.previewLoading = true;
      try {
        const blob = await this.$store.dispatch(
          TEMPLATE_DOCUMENTOS_PREVIEW_PDF,
          {
            aliasDocumento: this.aliasSelecionado,
            html: this.htmlDraft
          }
        );
        this.limparPreviewUrl();
        this.previewBlob = blob;
        this.previewUrl = window.URL.createObjectURL(blob);
        const previewUrl = this.previewUrl;
        await this.$swal
          .fire({
            title: "Pré-visualização PDF (A4)",
            html: `<iframe src="${previewUrl}" title="Preview PDF" style="width:100%;min-height:70vh;border:1px solid #e5e7eb;border-radius:8px"></iframe>`,
            width: 960,
            showCancelButton: true,
            confirmButtonText: "Baixar PDF",
            cancelButtonText: "Fechar",
            reverseButtons: true,
            customClass: {
              popup: "template-documentos-preview-swal"
            }
          })
          .then(result => {
            if (result.value) {
              this.onBaixarPreview();
            }
          });
      } finally {
        this.limparPreviewUrl();
        this.previewLoading = false;
      }
    },
    onBaixarPreview() {
      if (!this.previewBlob) return;
      const link = document.createElement("a");
      link.href = this.previewUrl;
      link.download = `preview-${this.aliasSelecionado}.pdf`;
      link.click();
    },
    limparPreviewUrl() {
      if (this.previewUrl) {
        window.URL.revokeObjectURL(this.previewUrl);
      }
      this.previewUrl = "";
      this.previewBlob = null;
    },
    async onCopiar() {
      try {
        await navigator.clipboard.writeText(this.htmlDraft || "");
        this.$vueOnToast.pop(
          "success",
          "HTML copiado para a área de transferência."
        );
      } catch (e) {
        this.$vueOnToast.pop("error", "Não foi possível copiar o HTML.");
      }
    }
  }
};
</script>

<style scoped>
.template-documentos-page {
  padding-bottom: 16px;
}

.template-documentos-loading {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.template-documentos-corpo {
  margin-top: 16px;
}

.template-documentos-col-editor,
.template-documentos-col-variaveis {
  display: flex;
}

.template-documentos-col-editor > *,
.template-documentos-col-variaveis > * {
  flex: 1;
  width: 100%;
  min-width: 0;
}
</style>

<style>
.template-documentos-preview-swal .swal2-styled.swal2-confirm {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: #fff !important;
}

.template-documentos-preview-swal .swal2-styled.swal2-cancel {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
  color: #fff !important;
}
</style>
